import * as libModelPortfolio from './modelPortfolio';
export const prefix = 'compositions/';
export const IDToName = (id) => {
    return libModelPortfolio.IDToName(id) + '/' + prefix + id.compositionID;
};
